/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ComuneEsercenteListFilter } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelComuneEsercenteSummaryDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListComuniEsercenteRequestParams {
    filter: ComuneEsercenteListFilter;
    pageable: Pageable;
}


export interface EsercenteComuniServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista paginata dei comuni con bandi che ammettono esercenti.
     * Un comune compare sse ha ≥1 TipoPratica con isModuloEsercentiEnabled&#x3D;true, tipologia ammessa (EsercenteCompatibilityMatrix) e stato visibile. Filtro opzionale q (substring nome+slug). Default sort: nome ASC.
     * @endpoint get /api/v1/esercente/comuni
* @param requestParameters
     */
    listComuniEsercente(requestParameters: ListComuniEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PagedModelComuneEsercenteSummaryDTO>;

}
